import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtilsV2 } from '@shared/utils';
import { RequestStrategyEnum, TransferRequestsApi, WithSignal, type TransferRequestLimitsResponse } from '@shared/api';

const getLimitsEffect = createEffect(({ signal }: WithSignal = {}) => TransferRequestsApi.getLimits(signal));
const clearEvent = createEvent();

const $dataStore = createStore<TransferRequestLimitsResponse>({ outgoingTransferLimit: 0 })
  .on(getLimitsEffect.done, (_, data) => data.result.data ?? { outgoingTransferLimit: 0 })
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getLimitsEffect.pending, (_, data) => data)
  .on(getLimitsEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getLimitsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getLimitsEffect, () => null)
  // .on(getLimitsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getLimitsEffect.fail, (_, data) =>
    ApiUtilsV2.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Transfers Limits. Please try again.'),
  )
  .on(getLimitsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

const getLimitsApi = ApiUtilsV2.wrapperApi(getLimitsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getLimitsApi.cancel());

export const $transferRequestsLimitsStore = {
  events: {
    getLimits: getLimitsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
